export const actions = {
    GET_NOTIFICATIONS: 'GET_NOTIFICATIONS',
    SET_NOTIFICATIONS: 'SET_NOTIFICATIONS',
    GET_NOTIFICATIONS_ALL: 'GET_NOTIFICATIONS_ALL',
    SET_NOTIFICATIONS_ALL: 'SET_NOTIFICATIONS_ALL',

    GET_READ_NOTIFICATIONS: 'GET_READ_NOTIFICATIONS',

    GET_READ_NOTIFICATION_ID: 'GET_READ_NOTIFICATION_ID',
    GET_ACTIVITY_NOTIFICATIONS: 'GET_ACTIVITY_NOTIFICATIONS',
    SET_ACTIVITY_NOTIFICATIONS: 'SET_ACTIVITY_NOTIFICATIONS',
    GET_READ_ACTIVITY_NOTIFICATIONS: 'GET_READ_ACTIVITY_NOTIFICATIONS',
    GET_ACTIVITY_NOTIFICATIONS_ALL: 'GET_ACTIVITY_NOTIFICATIONS_ALL',
    SET_ACTIVITY_NOTIFICATIONS_ALL: 'SET_ACTIVITY_NOTIFICATIONS_ALL',
};